/**
 * Customers/Login Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customers/Login template.
 *
 * @namespace addresses
 * @file vendors@template.collection.js
 * @file template.collection.js
 *
 */
import 'scripts/vue/templates/Account'